module.exports = __webpack_public_path__ + "img/kitkitphoto16.1343dbb3.jpg";